import React from "react";
import { DEPARTMENTS } from "@/lib/departments";
import { ROLE_LABELS } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { ShieldCheck, Check } from "lucide-react";

const ROLES = ["owner", "admin", "chief_estimator", "estimator", "business_development", "project_manager"];

export default function Roles() {
  return (
    <div className="px-6 sm:px-8 py-8">
      <div className="mb-6">
        <h1 className="font-display text-2xl font-bold tracking-tight text-black flex items-center gap-2">
          <ShieldCheck className="w-5 h-5 text-[#003E87]" /> Roles & access
        </h1>
        <p className="text-sm text-slate-500 mt-0.5">Who belongs to which department. A role sees only the departments checked here — everything else is hidden and blocked.</p>
      </div>

      <Card className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="roles-matrix">
          <thead>
            <tr className="border-b border-slate-200">
              <th className="text-left font-semibold text-slate-600 px-4 py-3">Department</th>
              {ROLES.map((r) => (
                <th key={r} className="text-center font-semibold text-slate-600 px-4 py-3 whitespace-nowrap">{ROLE_LABELS[r]}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {DEPARTMENTS.map((d) => (
              <tr key={d.key} className="border-b border-slate-100 last:border-0" data-testid={`roles-row-${d.key}`}>
                <td className="px-4 py-3">
                  <div className="font-medium text-black">{d.label}</div>
                  <div className="text-xs text-slate-400">{d.items.map((i) => i.label).join(" · ")}</div>
                </td>
                {ROLES.map((r) => (
                  <td key={r} className="text-center px-4 py-3">
                    {d.roles.includes(r)
                      ? <Check className="w-4 h-4 text-emerald-600 mx-auto" data-testid={`access-${d.key}-${r}`} />
                      : <span className="text-slate-200">—</span>}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <p className="text-xs text-slate-400 mt-4">Change someone's role on the Team page. Department access follows the role automatically.</p>
    </div>
  );
}
